// extracted by mini-css-extract-plugin
export default {"cards":"InvoicePayedProcessDetails_cards__BwLJX"};